import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { getFormInstance } from 'actions/templates';
import { FIELD_DESCRIPTION, FIELD_TITLE } from 'constants/fields';
import './Styles.scss';

var DisplayFormResults = /*#__PURE__*/function (_Component) {
  _inherits(DisplayFormResults, _Component);

  var _super = _createSuper(DisplayFormResults);

  function DisplayFormResults() {
    var _this;

    _classCallCheck(this, DisplayFormResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderTitle", function (field) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-label"
      }, field.value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDescription", function (field) {
      return /*#__PURE__*/React.createElement("div", null, field.value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (field) {
      var activeInstance = _this.props.activeInstance;
      var type = field.type.toLowerCase();
      var value = null;

      if (activeInstance != null) {
        var findResult = activeInstance.fieldResults.find(function (result) {
          return result.fieldName == field.name;
        });

        if (findResult != null) {
          value = findResult.value;
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "placeholder-input " + type,
        dangerouslySetInnerHTML: {
          __html: value
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderField", function (field, index) {
      if (field.type == FIELD_TITLE) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "form-row field"
        }, _this.renderTitle(field, index));
      }

      if (field.type == FIELD_DESCRIPTION) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "form-row field"
        }, _this.renderDescription(field, index));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "form-row"
      }, _this.renderInput(field, index));
    });

    return _this;
  }

  _createClass(DisplayFormResults, [{
    key: "render",
    value: function render() {
      var _this$props$activeIns;

      if (this.props.fields == null) {
        return null;
      }

      var fields = _toConsumableArray(this.props.fields);

      fields.sort(function (a, b) {
        return a.sortOrder > b.sortOrder ? 1 : -1;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "dynamic-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component"
      }, ((_this$props$activeIns = this.props.activeInstance) === null || _this$props$activeIns === void 0 ? void 0 : _this$props$activeIns.assigneeViewedCount) != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row field"
      }, this.props.translate('opened'), ": ", this.props.activeInstance.assigneeViewedCount) : null, fields.map(this.renderField)));
    }
  }]);

  return DisplayFormResults;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    activeInstance: ownProps.instance
  };
}

export default connect(mapStateToProps, {
  getFormInstance: getFormInstance
})(DisplayFormResults);